import React, { useState } from "react";
import axios from "axios";
import apiUrl from "../../Apiurl";
import stilePulsanti from "../../interfaccia/stilePulsanti";

const GIORNI_MAX = 30;
const selectClassName = "ba b--black-20 br2 pa2 w-100 sfondoBiancoTema";
const inputClassName = "input-reset ba b--black-20 br2 pa2 w-100";

function descriviEsclusioni(dati) {
  const note = [];
  if (dati.escluseAllineamento) {
    note.push(`${dati.escluseAllineamento} righe di allineamento escluse (si riprovano dalla loro procedura)`);
  }
  if (dati.oltreLimite) {
    note.push(`altre ${dati.oltreLimite} oltre il limite: rilancia il comando dopo questo giro`);
  }
  return note.length ? `\n\n${note.join("\n")}` : "";
}

/**
 * Ritenta in blocco le sync in errore di un sito negli ultimi N giorni, come
 * il tasto "Riprova" di ogni riga. Prima chiede all'API un'anteprima e una
 * conferma. Passa da axios: l'interceptor di App.js aggiunge l'username Domino.
 */
function RitentaErroriDashboard({ token, aggiorna }) {
  const [fonte, setFonte] = useState("");
  const [giorni, setGiorni] = useState("3");
  const [inCorso, setInCorso] = useState(false);

  const chiamaApi = (anteprima) =>
    axios.patch(
      apiUrl + "/prodotti/ps/retryDashboardErrors",
      { fonte, giorni: Number(giorni), anteprima },
      { headers: { Authorization: "Bearer " + token } },
    );

  const ritenta = async function () {
    if (!token || inCorso) return;
    if (!fonte) {
      window.alert("Scegli il sito di cui ritentare le sync in errore.");
      return;
    }
    const numeroGiorni = Number(giorni);
    if (!Number.isInteger(numeroGiorni) || numeroGiorni < 1 || numeroGiorni > GIORNI_MAX) {
      window.alert(`Indica un numero di giorni da 1 a ${GIORNI_MAX}.`);
      return;
    }

    setInCorso(true);
    try {
      const { data: anteprima } = await chiamaApi(true);
      const datiAnteprima = anteprima.data;
      if (!datiAnteprima.daRitentare) {
        window.alert(
          `Nessuna sync in errore da ritentare verso ${fonte} negli ultimi ${numeroGiorni} giorni.` +
            descriviEsclusioni(datiAnteprima),
        );
        return;
      }
      const conferma = window.confirm(
        `Ritentare ${datiAnteprima.daRitentare} sync in errore verso ${fonte} degli ultimi ${numeroGiorni} giorni?` +
          descriviEsclusioni(datiAnteprima),
      );
      if (!conferma) return;

      const { data: risposta } = await chiamaApi(false);
      const esito = risposta.data;
      const errori = esito.errori?.length
        ? `\n${esito.errori.length} non accodate per errore (es. ${esito.errori[0].codVS || esito.errori[0].id}: ${esito.errori[0].errore})`
        : "";
      window.alert(
        `Accodate ${esito.accodate}, già in coda ${esito.giaInCoda}.${errori}`,
      );
      aggiorna();
    } catch (error) {
      window.alert(
        "Ritentativo non riuscito: " +
          (error?.response?.data?.error || error?.message || "errore sconosciuto"),
      );
    } finally {
      setInCorso(false);
    }
  };

  return (
    <div className="flex items-end mr2">
      <label className="f7 mr2" style={{ width: "6rem" }}>
        <span className="db mb1">Sito errori</span>
        <select
          aria-label="Sito errori da ritentare"
          className={selectClassName}
          value={fonte}
          onChange={(event) => setFonte(event.target.value)}
        >
          <option value="">Scegli</option>
          <option value="VIG">VIG</option>
          <option value="BOT">BOT</option>
        </select>
      </label>
      <label className="f7 mr2" style={{ width: "5rem" }}>
        <span className="db mb1">Ultimi giorni</span>
        <input
          aria-label="Giorni da ritentare"
          type="number"
          min="1"
          max={GIORNI_MAX}
          className={inputClassName}
          value={giorni}
          onChange={(event) => setGiorni(event.target.value)}
        />
      </label>
      <div
        className={`gruppoInputRicercaOrizzontale ${inCorso ? "o-50" : "dim pointer"}`}
        onClick={ritenta}
      >
        <button className="tastoInputOrizzontale br3" disabled={inCorso}>
          {stilePulsanti.tastoRefreshAspetto}
        </button>
        <div className="ml2">{inCorso ? "Ritento..." : "Ritenta errori"}</div>
      </div>
    </div>
  );
}

export default RitentaErroriDashboard;
